function setRem() {
  const docEl = document.documentElement
  const designWidth = 750 // 确保这个值与你的设计稿宽度一致
  
  function recalc() {
    const clientWidth = docEl.clientWidth
    if (!clientWidth) return
    // 确保这里计算正确
    docEl.style.fontSize = (clientWidth / (designWidth/10)) + 'px'
  }
  
  const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  
  if (!document.addEventListener) return
  window.addEventListener(resizeEvt, recalc, false)
  document.addEventListener('DOMContentLoaded', recalc, false)
}

setRem()